import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppContextService } from '../../services/app-context.service';
import { OperationResult } from '../../models/server-result/operation-result';
import { Observable } from 'rxjs';
import { UploadDocumentsCountCriteria, UploadDocumentsResult, UploadDocumentsSearchCriteria } from './upload-documents-api.models';

@Injectable()
export class UploadDocumentsApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public uploadDocumentsSearch(criteria: UploadDocumentsSearchCriteria): Observable<OperationResult<UploadDocumentsResult[]>> {
		return this.http.post<OperationResult<UploadDocumentsResult[]>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/upload/documents/search')!,
			criteria
		);
	}

	public uploadDocumentsCount(criteria: UploadDocumentsCountCriteria): Observable<OperationResult<number>> {
		return this.http.post<OperationResult<number>>(
			this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAPIUrl() + '/upload/documents/searchCount')!,
			criteria
		);
	}
}
